/*
  Sleeping Dove — homepage engagement tracking (added 2026-06-21).
  Sends two custom events to GA4 (G-CF6LVNW70D) by REUSING the existing Google tag
  (gtag is already on the page via the Google & YouTube channel — confirmed live).
  We only emit events with send_to: the GA4 id, so we never touch page_view and never
  create a second tag — no double-counting, no Measurement Protocol secret.

    shop_cta_click     — a CTA that scrolls to the product cards was clicked
                         (params: cta_location, cta_label)
    shop_section_view  — the #shop product-card block scrolled into view (once/page)

  Product-card interaction (added 2026-09-30) — sent to GA4 AND to Meta's pixel, each
  ONCE PER SESSION (param: trigger = what fired it first):
    card_engage / CardEngage — ANY deliberate tap on a COMFORTER card: fill / size /
                         weight / colour, Add to cart, the $25 first-order line, notify-me
                         or signup email, picture / title / "See full details" / "Quick
                         details"; plus option picks / Add to cart / Buy now in a comforter
                         product page's buy box. The Meta ad set optimizes toward this.
    card_commit / CardCommit — the same minus the look-only taps (pictures, details).
                         Reporting + fallback target only.
    Comforter only: the sheet-set card and the sheet / pillowcase / gift-card product
    pages are NOT counted (James 2026-09-30).
    NOT counted either (2026-10-05): the star-rating line and the customer photo reviews
    under the cards (data-sd-nocard) — added after the ad set started learning.

    card_select       — GA4 ONLY, EVERY fill / weight / size / colour pick on a comforter card
                         or comforter product page (added 2026-10-10; not once-per-session, never
                         sent to Meta). Params: select_option (fill | weight | size | color),
                         select_value, select_price (price showing after the pick),
                         select_surface (card_phone | card_desktop | pdp).
    signup_submit     — GA4 ONLY, every Klaviyo form submit (added 2026-10-10); param form_id.
                         Before this a signup reached GA4 only as card_engage trigger=email,
                         and only when it was the session's first tap.

    rating_click      — the star-rating line or "Read all reviews" was tapped
                         (param: rating_location = hero | card | pdp | strip | strip_all)
    reviews_more_click — "More reviews" under the customer reviews list was tapped
  Meta's pixel (fbq) is injected late by Shopify's pixel manager, so sends wait for it;
  if it never loads (no consent, blocked) nothing is sent.

  Guards: no-op in the theme editor (Shopify.designMode) and on any page where the
  Google tag didn't load, so behavior matches the channel pixel (which also skips the editor).
*/
(function () {
  if (window.Shopify && window.Shopify.designMode) return;

  var GA4 = 'G-CF6LVNW70D';
  function send(name, params) {
    if (typeof window.gtag !== 'function') return;
    params = params || {};
    params.send_to = GA4;
    try { window.gtag('event', name, params); } catch (e) {}
  }

  // 1) Clicks on any CTA that targets the product cards (#shop): hero button,
  //    sticky bars (desktop + mobile), and every "Shop" link on the page.
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var a = t.closest('a[href*="#shop"], .sd-btn-hero-primary, a.sd-sticky-mobile, .sd-sticky-cta a');
    if (!a) return;
    var loc = a.closest('.sd-menu-drawer-panel') ? 'drawer'
            : a.closest('.sd-sticky-mobile, .sd-sticky-cta') ? 'sticky'
            : a.closest('#hero, .sd-hero-section') ? 'hero'
            : (function () { var s = a.closest('section[id], [id^="shopify-section"] > section, .sd-final-section, .sd-shop-link'); return (s && s.id) ? s.id : 'other'; })();
    send('shop_cta_click', {
      cta_location: loc,
      cta_label: (a.textContent || '').replace(/\s+/g, ' ').trim().slice(0, 60)
    });
    // Drawer shop pill: close the drawer so the same-page #shop anchor is visible.
    if (a.hasAttribute && a.hasAttribute('data-sd-drawer-shop')) {
      var d = document.getElementById('sd-menu-drawer-details');
      if (d) d.removeAttribute('open');
    }
  }, true);

  // 1b) First-order ($25) doorways — [data-sd-open-form] buttons (cards strip, PDP
  //     price line) open the Klaviyo signup form and log which surface was used.
  //     Form id Wwsruk = "Sign-up $25 Product Page Popup" (stable since 2025-11).
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var b = t.closest('[data-sd-open-form]');
    if (!b) return;
    send('signup_offer_click', { offer_location: b.getAttribute('data-sd-open-form') || 'unknown' });
    try {
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(['openForm', 'Wwsruk']);
    } catch (err) {}
  }, true);

  // 1c) Rating line / "Read all reviews" taps (added 2026-10-05): which surface sends people
  //     to the reviews. rating_location = hero | card | pdp | strip | strip_all.
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var r = t.closest('[data-sd-rating]');
    if (r) { send('rating_click', { rating_location: r.getAttribute('data-sd-rating') || 'other' }); return; }
    if (t.closest('[data-sd-rs-all]')) { send('rating_click', { rating_location: 'strip_all' }); return; }
    // "More reviews" under the customer photo reviews (reveals the rest in place).
    if (t.closest('[data-sd-rs-expand]')) send('reviews_more_click', {});
  }, true);

  // 2) Product-card section (#shop) scrolled into view — once per page load.
  function observeShop() {
    var shop = document.getElementById('shop');
    if (!shop || !('IntersectionObserver' in window)) return;
    var fired = false;
    var io = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (entries[i].isIntersecting && !fired) {
          fired = true;
          send('shop_section_view', { section_id: 'shop' });
          io.disconnect();
          break;
        }
      }
    }, { threshold: 0.1 });
    io.observe(shop);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', observeShop);
  else observeShop();

  // 3) Product-card interaction → GA4 + Meta, once per session each (see header).
  var TAG_WAIT_MS = 15000;
  function whenReady(fnName, call) {
    var t0 = Date.now();
    (function attempt() {
      if (typeof window[fnName] === 'function') {
        try { call(window[fnName]); } catch (e) {}
      } else if (Date.now() - t0 < TAG_WAIT_MS) {
        setTimeout(attempt, 500);
      }
    })();
  }
  var firedMem = {};
  function oncePerSession(key) {
    if (firedMem[key]) return false;
    firedMem[key] = 1;
    try {
      if (window.sessionStorage.getItem(key)) return false;
      window.sessionStorage.setItem(key, '1');
    } catch (e) {}
    return true;
  }
  var COMMIT = { pick: 1, cart: 1, offer: 1, email: 1 };
  function cardEvent(trigger) {
    var pairs = [['sd_card_engage', 'card_engage', 'CardEngage']];
    if (COMMIT[trigger]) pairs.push(['sd_card_commit', 'card_commit', 'CardCommit']);
    pairs.forEach(function (p) {
      if (!oncePerSession(p[0])) return;
      whenReady('gtag', function (gtag) { gtag('event', p[1], { trigger: trigger, send_to: GA4 }); });
      whenReady('fbq', function (fbq) { fbq('trackCustom', p[2], { trigger: trigger }); });
    });
  }
  function classifyCardTap(t) {
    // Rating line + customer photo reviews (added 2026-10-05) are marked data-sd-nocard so the
    // card events keep the meaning the Meta ad set was trained on (taps on the card itself).
    if (t.closest('[data-sd-nocard]')) return null;
    if (t.closest('[data-sd-open-form]')) return 'offer';            // $25 first-order line
    // Product page buy box — where a card's "See full details" leads; commit taps count there too.
    //   COMFORTER product pages only (James 2026-09-30: "we are a comforter company").
    if (t.closest('.product__info-wrapper')) {
      if (!/comforter/.test(window.location.pathname)) return null;
      if (t.closest('button[name="add"], .shopify-payment-button')) return 'cart';
      if (t.closest('variant-selects') && t.closest('input, label, select')) return 'pick';
      return null;
    }
    if (!t.closest('.sd-shop-section')) return null;
    if (t.closest('[data-sd-acc]')) return null;                      // sheet-set card: NOT counted
    if (t.closest('button[name="add"]')) return 'cart';
    if (t.closest('.sd-notify-form')) return t.closest('input, button') ? 'email' : null;
    if (t.closest('input[type="radio"], label[for]')) return 'pick'; // fill / size / weight / colour
    if (t.closest('a[href], summary')) return 'details';              // picture, title, See full details, Quick details, Care Guide
    return null;
  }
  document.addEventListener('click', function (e) {
    if (e.isTrusted === false) return;                                // real taps only
    var t = e.target;
    if (!t || !t.closest) return;
    var trigger = classifyCardTap(t);
    if (trigger) cardEvent(trigger);
  }, true);
  // Email signup submitted in any Klaviyo form (the $25 form, the popup).
  window.addEventListener('klaviyoForms', function (e) {
    if (!(e && e.detail && e.detail.type === 'submit')) return;
    cardEvent('email');
    send('signup_submit', { form_id: e.detail.formId || 'unknown' });
  });

  // 4) Every option pick on a comforter card or comforter product page → GA4 only. Same scope
  //    as the 'pick' tap above; listens on change so re-tapping the selected value sends nothing.
  function shownPrice(el) {
    if (!el) return null;
    var c = el.cloneNode(true);
    c.querySelectorAll('s').forEach(function (x) { x.remove(); });
    var m = (c.textContent || '').replace(/,/g, '').match(/\d+(\.\d+)?/);
    return m ? parseFloat(m[0]) : null;
  }
  document.addEventListener('change', function (e) {
    if (e.isTrusted === false || window.sdAutoPick) return;      // sdAutoPick: the product page's own colour follow-through, not a shopper's pick
    var t = e.target;
    if (!t || t.type !== 'radio' || !t.closest) return;
    var surface, priceEl, wait = 50;                              // cards update the price in the same tick
    var pdp = t.closest('.product__info-wrapper');
    if (pdp) {
      if (!/comforter/.test(window.location.pathname) || !t.closest('variant-selects')) return;
      surface = 'pdp';
      wait = 1500;                                                    // Dawn re-renders the price after a fetch
      priceEl = function () {
        var p = pdp.querySelector('.price');
        return p && p.querySelector(p.classList.contains('price--on-sale') ? '.price__sale .price-item--sale' : '.price__regular .price-item--regular');
      };
    } else {
      var shop = t.closest('.sd-shop-section');
      if (!shop || t.closest('[data-sd-acc]') || t.closest('[data-sd-nocard]')) return;
      var card = t.closest('.sd-sku-card');
      surface = card ? 'card_desktop' : 'card_phone';
      priceEl = function () { return card ? card.querySelector('.sd-sku-price') : shop.querySelector('.sd-mob-price'); };
    }
    var fs = t.closest('fieldset');
    var isFill = !!(fs && fs.getAttribute('data-mob-option') === 'fill');
    var name = isFill ? 'fill'
             : (fs && (fs.getAttribute('data-mob-option-name') || fs.getAttribute('data-option-name')))
               || (fs && fs.querySelector('legend') && fs.querySelector('legend').textContent) || t.name || 'unknown';   // product page: the legend names the option
    name = name.toLowerCase();                                        // Shopify option names vary ("Bedding Size", "Colour")
    name = /size/.test(name) ? 'size' : /weight/.test(name) ? 'weight' : /colou?r/.test(name) ? 'color' : name;
    var value = t.value;
    if (isFill) {                                                     // fill radios carry an index; the label has the name
      var lab = t.id && document.querySelector('label[for="' + t.id + '"]');
      if (lab) value = (lab.textContent || '').replace(/\s+/g, ' ').trim();
    }
    setTimeout(function () {
      var params = { select_option: name, select_value: String(value).slice(0, 60), select_surface: surface };
      var price = shownPrice(priceEl());
      if (price !== null) params.select_price = price;
      send('card_select', params);
    }, wait);
  });
})();
